export default "__VITE_ASSET__CzH7yX6p__"